import { Stack, Text, theme } from '@veeqo/ui';
import { ContentType, copy } from 'components/Landing/content';

export const VeeqoSubtitle = ({ contentType }: { contentType: ContentType }) => (
  <Stack direction="vertical" alignX="center" style={{ minHeight: theme.sizes[12] }}>
    <Text variant="headingLarge" style={{ textAlign: 'center' }}>
      {copy[contentType].subtitleText[0]}
    </Text>
    <Text variant="headingMedium" style={{ textAlign: 'center', fontWeight: '500' }}>
      {copy[contentType].subtitleText[1]}
    </Text>
  </Stack>
);
